import React from "react";
import { TransitionGroup, CSSTransition } from "react-transition-group";
import {
  NOTIFICATION_TYPE_MODAL,
  NOTIFICATION_TYPE_TOAST
} from "../../constants/notification";
import Modal from "./Modal";
import Toast from "./Toast";

const NotificationList = ({ notifications, dismiss }) => {
  // filter out notifications into two groups: toasts and modals
  const { toasts, modals } = notifications.reduce(
    (acc, note) => {
      const { type, ...rest } = note;
      if (type === NOTIFICATION_TYPE_MODAL) {
        acc.modals.push(rest);
      } else if (type === NOTIFICATION_TYPE_TOAST) {
        acc.toasts.push(rest);
      }
      return acc;
    },
    { toasts: [], modals: [] }
  );

  return (
    <div className="notifications">
      {modals.map(modal => {
        const { body, ...rest } = modal;
        return (
          <Modal key={modal.id} {...rest} dismiss={dismiss}>
            {body}
          </Modal>
        );
      })}
      <div className="toast-container">
        <TransitionGroup component={null}>
          {toasts.map(toast => {
            const { message, ...rest } = toast;
            return (
              <CSSTransition
                key={toast.id}
                classNames="toast"
                timeout={{ enter: 250, exit: 500 }}
              >
                <Toast dismiss={dismiss} {...rest}>
                  {message}
                </Toast>
              </CSSTransition>
            );
          })}
        </TransitionGroup>
      </div>
    </div>
  );
};

export default NotificationList;
